module.exports = __webpack_public_path__ + "src/assets/img/DeMountain.35d93f17.png";